import React from "react";
import ChatNeutral from "../../../assets/images/chat-neutral.png";
import { ActiveJourneyIcon, InactiveJourneyIcon } from "../../../assets/icon";
import { UserResponse } from "../../../components/types";

// Shared by the default CrmDashboard and conversation_agent's Home — split
// out to a standalone file (rather than exported from crm-pages/home/index.tsx)
// so conversation-agent-home.tsx can import them without a circular
// index.tsx <-> conversation-agent-home.tsx dependency.

interface ProfileCardProps {
  user: UserResponse | null;
}

export const ProfileCard: React.FC<ProfileCardProps> = ({ user }) => (
  <div className="bg-white dark:bg-gray-900 rounded-2xl p-5 shadow-sm border border-gray-100 dark:border-gray-800">
    <div className="flex items-center gap-2 mb-3">
      <img src={ChatNeutral} alt="Profile" />
      <span className="text-sm font-semibold text-gray-800 dark:text-gray-100">{user?.payload?.org_phone}</span>
    </div>

    <a
      href={`https://${user?.payload?.org_domain_name}`}
      target="_blank"
      rel="noopener noreferrer"
      className="text-[14px] border-t border-b border-gray-200 dark:border-gray-700 p-1 block text-[#4338CA] underline"
    >
      {user?.payload?.org_domain_name || "N/A"}
    </a>
    <p className="text-[14px] text-[#434343] dark:text-gray-300 border-t border-b border-gray-200 dark:border-gray-700 p-1">{user?.payload?.industry || "N/A"}</p>
    <p className="text-[14px] text-[#434343] dark:text-gray-300 border-t border-b border-gray-200 dark:border-gray-700 p-1">{user?.payload?.org_about || "N/A"}</p>
    <p className="text-[14px] text-[#434343] dark:text-gray-300 border-t capitalize border-b border-gray-200 dark:border-gray-700 p-1">{user?.payload?.country || "N/A"}</p>
  </div>
);

const journeySteps = [
  { label: "Connect a Channel", done: true },
  { label: "Add Team Members", done: false },
  { label: "Assign Conversations", done: false },
  { label: "Engage Potential Leads", done: false },
];

export const JourneyCard: React.FC = () => (
  <div className="bg-white dark:bg-gray-900 rounded-2xl p-5 shadow-sm border border-gray-100 dark:border-gray-800">
    <div className="flex justify-between items-center mb-4">
      <h2 className="text-[16px] font-medium flex gap-2 text-[#3A3428] dark:text-gray-100">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M10.5 10.5L16 8L13.5 13.5L8 16L10.5 10.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        Kickstart your CRM journey
      </h2>
      <span className="text-xs bg-[#E5E7EB] dark:bg-gray-800 dark:text-gray-200 px-2 py-1 rounded-full">1 out of 5 complete</span>
    </div>
    <ul className="space-y-3 flex-col">
      {journeySteps.map((step) => (
        <li key={step.label} className="flex text-[14px] border-t border-gray-200 dark:border-gray-700 items-center gap-3">
          <span className="rounded-full flex items-center justify-center pt-1 font-bold">
            {step.done ? <ActiveJourneyIcon /> : <InactiveJourneyIcon />}
          </span>
          <span className={`text-sm ${step.done ? "text-[#7B7B7B] font-semibold dark:text-gray-500 line-through" : "text-gray-700 dark:text-gray-300"}`}>
            {step.label}
          </span>
        </li>
      ))}
    </ul>
  </div>
);
